export const fr = {
  nav: {
    services: "Mandats",
    solutions: "Solutions",
    industries: "Secteurs",
    work: "Preuves",
    about: "La firme",
    insights: "Perspectives",
    contact: "Contact",
    talkToUs: "Discuter d’un processus coûteux",
    seeWhatWeBuild: "Voir les modèles de solution",
    servicesOverview: "Mandats IA de production",
    industriesOverview: "Adéquation par secteur",
    primaryAria: "Navigation principale",
    mobileAria: "Navigation mobile",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
  },
  offerCard: {
    learnMore: "Ouvrir la fiche de service",
  },
  home: {
    ctaHeadline: "Présentez le processus coûteux que votre équipe ne devrait plus subir.",
    ctaDescription:
      "L’examen vérifie le coût, les limites du processus, les données, la responsabilité, le risque et les preuves avant de recommander une mise en œuvre, un travail de préparation, un outil existant ou aucun développement.",
  },
  about: {
    heroLabel: "À propos de Vert AI",
    heroTitle: "Une responsabilité au plus haut niveau, de la première décision sur le processus jusqu’à la production.",
    heroSubtitle:
      "Vert AI est une firme canadienne qui corrige les processus coûteux du commerce en combinant conception opérationnelle, IA en production, données fiables, contrôles, adoption et mesure.",
    secondaryCta: "Voir les types de mandats",
    heroProof: [
      {
        label: "Priorité aux opérations de commerce",
        desc: "Vert AI se concentre sur le commerce de détail, le commerce électronique, les biens de consommation et les réseaux multisites de taille intermédiaire au Canada.",
      },
      {
        label: "Livraison dirigée par le fondateur",
        desc: "Guillaume dirige le cadrage et les décisions techniques clés; des spécialistes sélectionnés contribuent lorsque le mandat l’exige.",
      },
      {
        label: "Travail par phases et fondé sur les preuves",
        desc: "Les projets avancent par décisions délimitées et s’élargissent seulement lorsque le processus, les contrôles, l’adoption et la valeur peuvent être examinés.",
      },
    ],
    whyExistsLabel: "Pourquoi Vert existe",
    whyExistsTitle: "Le travail n’est pas terminé tant que le changement opérationnel ne tient pas.",
    whyExistsP1:
      "Les entreprises ont besoin d’un meilleur débit, de meilleures décisions, de données fiables, d’une autorité humaine claire et de systèmes qui demeurent observables après le lancement.",
    whyExistsP2:
      "Vert AI existe pour les entreprises qui ont besoin de repenser le processus autour de l’IA : choisir le bon processus, établir la mesure de référence, préparer les données, intégrer le système, évaluer les défaillances, définir la validation humaine et surveiller l’adoption et la valeur. Tous les processus ne devraient pas être automatisés.",
    principlesLabel: "Principes",
    principlesTitle: "Comment Vert AI décide ce qui mérite d’être construit.",
    principles: [
      {
        title: "Commencer par les processus coûteux, pas les démos technologiques.",
        desc: "La première question est où la vitesse, la qualité, le coût ou la précision décisionnelle créent déjà une pression mesurable.",
      },
      {
        title: "Définir la mesure de référence avant de construire.",
        desc: "Temps de cycle, taux d’exception, effort de validation, coût d’erreur, adoption et qualité des décisions doivent avoir un point de départ.",
      },
      {
        title: "Rendre la préparation des données visible.",
        desc: "Qualité des sources, responsabilité, autorisations, sémantique et instrumentation manquante sont exposées avant de devenir des risques de production.",
      },
      {
        title: "Maintenir une supervision humaine lorsque le risque, le jugement ou l’incidence sur la clientèle comptent.",
        desc: "L’IA doit acheminer, recommander, rédiger, récupérer et attribuer des cotes, avec des parcours de validation clairs lorsque l’imputabilité, la confidentialité ou l’expérience client comptent.",
      },
      {
        title: "Concevoir pour la production dès le premier jour.",
        desc: "Évaluation, observabilité, logique de repli, contrôle d’accès et responsabilité opérationnelle font partie de la conception du système.",
      },
      {
        title: "Mesurer l’adoption et l’impact opérationnel.",
        desc: "Un système ne réussit pas parce qu’il est lancé. Il réussit quand les gens l’utilisent et que le processus s’améliore.",
      },
      {
        title: "Élargir seulement après avoir gagné la confiance.",
        desc: "Le prochain processus doit venir après que le premier a prouvé sa fiabilité, son adoption et sa valeur opérationnelle.",
      },
    ],
    differenceLabel: "Ce qui rend le travail différent",
    differenceTitle: "Stratégie, données, processus et ingénierie de production restent connectés.",
    differenceItems: [
      {
        title: "Stratégie et construction dans la même équipe.",
        desc: "Les personnes qui formulent la recommandation restent proches de l’architecture, de la mise en œuvre et des contraintes de lancement.",
      },
      {
        title: "IA + données + processus + logique décisionnelle.",
        desc: "Une IA utile dépend souvent de parcours de données propres, de règles explicites, d’interfaces utilisables et d’un traitement clair des exceptions.",
      },
      {
        title: "Contrôles de production inclus.",
        desc: "Évaluation, surveillance, auditabilité, validation humaine et comportements de repli font partie intégrante du périmètre.",
      },
      {
        title: "Responsabilité et gouvernance claires.",
        desc: "Chaque système a besoin de responsables pour les données, la logique, la validation, la performance et la gestion du changement.",
      },
    ],
    trustLabel: "Confiance et discipline opérationnelle",
    trustTitle: "La confiance se construit dans le système, pas au lancement.",
    trustIntro:
      "L’IA de production doit être vérifiable. Vert AI traite l’évaluation, la surveillance, le traitement des exceptions, la qualité des données, la confidentialité, l’examen de sécurité, la responsabilité, l’adoption et la mesure du rendement comme des exigences de mise en œuvre.",
    trustItems: [
      {
        title: "Évaluation",
        desc: "Jeux de test, critères d’acceptation, cas limites et boucles de validation sont définis pour juger le système honnêtement.",
      },
      {
        title: "Surveillance",
        desc: "Utilisation, qualité, latence, dérive, modes de défaillance et mesures opérationnelles doivent rester visibles après le lancement.",
      },
      {
        title: "Traitement des exceptions",
        desc: "Seuils de confiance, acheminement des exceptions et parcours de validation humaine gardent le jugement au bon endroit.",
      },
      {
        title: "Qualité des données",
        desc: "Intrants, transformations, définitions et responsabilités sont explicites pour éviter que le système hérite d’ambiguïté cachée.",
      },
      {
        title: "Confidentialité et sécurité",
        desc: "Accès, autorisations, données sensibles, exposition aux fournisseurs et examen de sécurité sont considérés avant d’automatiser les processus.",
      },
      {
        title: "Gouvernance",
        desc: "Contrôle des changements, documentation, responsabilité et cadence d’examen gardent le système utile quand l’entreprise change.",
      },
    ],
    founderLabel: "Le fondateur",
    founderName: "Guillaume Belisle",
    founderRole: "Fondateur, Vert AI",
    founderTitle: "Dirigé par le fondateur lorsque le jugement compte; soutenu par des spécialistes lorsque le mandat l’exige.",
    founderP1:
      "Guillaume Belisle est scientifique des données, ingénieur en apprentissage automatique et concepteur de systèmes d’IA. Son expérience professionnelle antérieure comprend la conception et la livraison de systèmes d’IA, d’apprentissage automatique et de données dans des environnements comme Louis Vuitton, Canada Goose, Lowe’s et Home Hardware. Ces entreprises ne sont pas présentées comme des clientes de Vert AI.",
    founderP2:
      "Guillaume dirige la sélection des occasions, le cadrage, l’architecture et les décisions techniques clés. Des spécialistes sélectionnés peuvent soutenir l’ingénierie, les données, la conception, la sécurité ou le domaine lorsque la portée approuvée le requiert.",
    founderP3:
      "L’approche opérationnelle est commerciale et technique à la fois. Si un système ne peut pas être mesuré, gouverné, adopté et utilisé avec confiance, il n’est pas prêt.",
    founderP4:
      "Vert AI ne convient pas à une démonstration sans responsable, à un déploiement d’outil prédéterminé sans analyse opérationnelle ni à une promesse de rendement sans mesure de référence et sans attribution défendable.",
    ctaHeadline: "Présentez le processus coûteux qui doit fonctionner autrement.",
    ctaDesc:
      "L’examen d’adéquation portera sur la valeur opérationnelle, les données, la responsabilité, le risque et le type de mandat le plus crédible — y compris une recommandation de ne pas construire lorsque cela s’impose.",
  },
  insights: {
    heroLabel: "Perspectives",
    heroTitle: "Prenez la prochaine décision en IA à partir de preuves, pas d’un effet d’entraînement.",
    heroSubtitle:
      "Seize guides pratiques pour les responsables des opérations et des données, les finances, les TI, la sécurité et la direction qui évaluent la valeur, la préparation, les contrôles, l’économie et le risque de production.",
    featured: "À la une",
    readArticle: "Lire le guide opérationnel",
    articles: [
      {
        slug: "production-grade-ai",
        cat: "IA de production",
        title: "IA prête pour la production : la norme d’exploitation au-delà de la démo",
        desc: "Un système d’IA de production doit rester utile avec les vraies données, la vraie charge et les vrais risques. Ce guide définit le processus, l’évaluation, les contrôles, la surveillance et les responsabilités requises.",
        seoTitle: "IA prête pour la production : exigences clés | Vert AI",
        seoDescription: "Découvrez les exigences d’un système d’IA en production : données fiables, évaluation, contrôles, surveillance, responsabilités et mesure de la valeur.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "IA prête pour la production, système d’IA en production, déploiement de l’IA, évaluation de l’IA, surveillance de l’IA, contrôles de l’IA",
        tags: ["IA de production", "Systèmes d’IA", "Évaluation", "Surveillance", "Gouvernance"],
      },
      {
        slug: "workflows-deserve-ai",
        cat: "Sélection des processus",
        title: "Quels processus méritent l’IA? Un cadre de sélection pour la production",
        desc: "Un cadre pratique pour choisir les processus selon la valeur opérationnelle, la fréquence, une part de jugement bien circonscrite, la préparation des données, le risque et la capacité d’utiliser le résultat.",
        seoTitle: "Quels processus méritent l’IA? Cadre de sélection | Vert AI",
        seoDescription: "Évaluez les processus selon la valeur, la fréquence, les données, le risque et la capacité d’agir afin de choisir un premier cas d’IA crédible.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "sélection processus IA, choisir cas d’usage IA, cadre automatisation IA, préparation IA, premier processus IA",
        tags: ["Sélection des processus", "Préparation à l’IA", "Automatisation", "Valeur opérationnelle", "IA de production"],
      },
      {
        slug: "vet-ai-vendor",
        cat: "Guide d’achat",
        title: "Comment évaluer un fournisseur d’IA : preuves, contrôles, droits et sortie",
        desc: "Évaluez chaque fournisseur avec un même cas de production. Testez les preuves, l’architecture, les autorisations, les responsabilités, le coût total, les droits sur les données, la portabilité et les modalités de sortie.",
        seoTitle: "Comment évaluer un fournisseur d’IA | Vert AI",
        seoDescription: "Comparez les fournisseurs d’IA selon leurs preuves, leur architecture, leurs contrôles, leurs coûts, leurs droits sur les données et leur stratégie de sortie.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "évaluer fournisseur IA, sélection fournisseur IA, approvisionnement IA, droits données IA, portabilité IA, vérification diligente IA",
        tags: ["Fournisseurs d’IA", "Approvisionnement", "Vérification diligente", "Droits sur les données", "IA de production"],
      },
      {
        slug: "ai-pilots-fail-before-production",
        cat: "IA de production",
        title: "Pourquoi les pilotes d’IA stagnent avant la production",
        desc: "Les pilotes stagnent lorsqu’une capacité est testée sans le vrai parcours de données, le contrat de processus, les contrôles, les exceptions, le responsable et l’économie unitaire nécessaires à la production.",
        seoTitle: "Pourquoi les pilotes d’IA échouent avant la production | Vert AI",
        seoDescription: "Voyez pourquoi les pilotes d’IA stagnent sans processus défini, données réelles, contrôles, responsable, intégration et mesure de référence.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "échec pilotes IA, IA de production, preuve de concept IA, préparation déploiement IA, responsabilité processus IA, rendement pilote IA",
        tags: ["IA de production", "Pilotes d’IA", "Conception des processus", "Préparation des données", "Économie de l’IA"],
      },
      {
        slug: "production-ai-readiness-checklist-mid-market",
        cat: "Préparation à l’IA",
        title: "Liste de préparation à l’IA de production pour les entreprises de taille intermédiaire",
        desc: "Une liste de vérification au niveau du processus : valeur, clarté, données, responsabilité, risque, validation humaine, intégration, coût total et mesure de référence.",
        seoTitle: "Préparation à l’IA en entreprise : liste de contrôle | Vert AI",
        seoDescription: "Vérifiez si un processus est prêt pour l’IA en production selon sa valeur, ses données, sa responsabilité, ses risques, son intégration et sa mesure.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "liste de préparation à l’IA, IA pour entreprise de taille intermédiaire, préparation de l’IA en production, évaluation des processus, préparation des données, grille d’IA",
        tags: ["Préparation à l’IA", "Entreprise de taille intermédiaire", "Évaluation des processus", "Données", "IA de production"],
      },
      {
        slug: "decision-intelligence-vs-business-intelligence",
        cat: "Systèmes décisionnels",
        title: "Intelligence décisionnelle ou intelligence d’affaires : de la visibilité à l’action",
        desc: "L’intelligence d’affaires crée une visibilité fiable. L’intelligence décisionnelle ajoute modèles, règles, contraintes, voies d’action et rétroaction lorsque les décisions répétées demeurent lentes ou incohérentes.",
        seoTitle: "Intelligence décisionnelle ou intelligence d’affaires? | Vert AI",
        seoDescription: "Comprenez quand dépasser les tableaux de bord pour relier données, modèles, règles, contraintes, actions et rétroaction dans un système décisionnel.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "intelligence décisionnelle intelligence affaires, BI systèmes décisionnels, moteur décisionnel, analytique opérationnelle, système décision IA",
        tags: ["Intelligence décisionnelle", "Intelligence d’affaires", "Systèmes décisionnels", "Analytique", "Processus opérationnels"],
      },
      {
        slug: "ai-governance-monitoring-evaluation-human-review",
        cat: "Gouvernance de l’IA",
        title: "Gouvernance de l’IA pour les opérateurs : évaluation, surveillance et validation",
        desc: "Rendez la gouvernance opérationnelle avec un inventaire, des niveaux de risque, des droits de décision, des dossiers d’acceptation, la surveillance, la validation humaine, les incidents et le retrait.",
        seoTitle: "Gouvernance de l’IA en production : guide pratique | Vert AI",
        seoDescription: "Mettez en place une gouvernance de l’IA fondée sur l’inventaire, les risques, l’évaluation, la surveillance, la validation humaine et les incidents.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "gouvernance IA opérateurs, surveillance IA, évaluation IA, validation humaine IA, incident IA, gouvernance production",
        tags: ["Gouvernance de l’IA", "Surveillance", "Évaluation", "Validation humaine", "Contrôles de production"],
      },
      {
        slug: "what-agentic-ai-should-automate",
        cat: "IA agentive",
        title: "Ce que l’IA agentive devrait et ne devrait pas automatiser",
        desc: "Utilisez l’IA agentive pour un travail défini, en plusieurs étapes et vérifiable, avec des outils et une autorité encadrés. Gardez les décisions ambiguës, lourdes ou irréversibles sous contrôle humain.",
        seoTitle: "IA agentive : quoi automatiser et quoi encadrer | Vert AI",
        seoDescription: "Déterminez quels processus conviennent à l’IA agentive et où limiter les outils, l’autorité et l’autonomie par des contrôles et une validation humaine.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "automatisation IA agentive, IA agentique processus, agents IA automatisation, autonomie limitée, validation humaine agents",
        tags: ["IA agentive", "Agents d’IA", "Automatisation des processus", "Autonomie limitée", "Validation humaine"],
      },
      {
        slug: "data-foundation-behind-useful-ai-systems",
        cat: "Plateformes de données",
        title: "La fondation de données derrière les systèmes d’IA utiles",
        desc: "L’IA de production exige des contrats de données propres au cas, des identités résolues, une sémantique gouvernée, des contrôles de qualité, des autorisations, de la fraîcheur, du lignage et des responsables.",
        seoTitle: "Fondations de données pour des systèmes d’IA fiables | Vert AI",
        seoDescription: "Préparez les données nécessaires à l’IA en production : contrats, qualité, sémantique, autorisations, fraîcheur, lignage et responsabilités.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "fondation données IA, données prêtes pour IA, plateforme données IA, couche sémantique, qualité données IA, données production",
        tags: ["Plateformes de données", "Données prêtes pour l’IA", "Couche sémantique", "Qualité des données", "IA de production"],
      },
      {
        slug: "measure-ai-roi-before-building",
        cat: "Économie de l’IA",
        title: "Comment mesurer le rendement de l’IA avant de bâtir",
        desc: "Cadrez le rendement de l’investissement avec la mesure de référence du processus, l’arbre de valeur, le coût complet, un scénario contrefactuel crédible, l’économie unitaire et des jalons de validation.",
        seoTitle: "Mesurer le rendement de l’IA avant de bâtir | Vert AI",
        seoDescription: "Cadrez le rendement d’un projet d’IA avec une mesure de référence, un arbre de valeur, le coût complet, l’économie unitaire et des jalons de validation.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "rendement IA, ROI IA, analyse de rentabilité IA, mesure de référence IA, économie unitaire IA, coût total IA",
        tags: ["Rendement de l’IA", "Analyse de rentabilité", "Économie unitaire", "Mesure", "Barrières d’investissement"],
      },
      {
        slug: "dashboard-to-decision-engine-production",
        cat: "Systèmes décisionnels",
        title: "Du tableau de bord au moteur décisionnel : ce qui change en production",
        desc: "Un moteur décisionnel relie des intrants gouvernés, une logique analytique, des politiques d’affaires, une voie d’action et la rétroaction. Voyez quand dépasser le tableau et comment le faire par étapes.",
        seoTitle: "Du tableau de bord au moteur décisionnel | Vert AI",
        seoDescription: "Voyez comment relier données gouvernées, modèles, règles, contraintes, actions et rétroaction pour passer de la visibilité à de meilleures décisions.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "tableau de bord moteur décisionnel, moteur de décision, intelligence décisionnelle, système décision production, analytique opérationnelle",
        tags: ["Moteurs décisionnels", "Intelligence décisionnelle", "Intelligence d’affaires", "Processus opérationnels", "IA de production"],
      },
      {
        slug: "human-in-the-loop-economics-2026",
        cat: "Exploitation de l’IA",
        title: "Économie de la validation humaine : concevoir un vrai volet d’exploitation",
        desc: "La validation humaine est un contrôle et un coût. Concevez la décision, les preuves, l’autorité, la file, les ressources, les seuils et la mesure selon la conséquence, l’incertitude et la réversibilité.",
        seoTitle: "Coût de la validation humaine en IA | Vert AI",
        seoDescription: "Concevez la validation humaine selon le risque, l’incertitude et la réversibilité, puis mesurez sa charge, ses délais, ses coûts et ses résultats.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "validation humaine IA, humain dans la boucle, coût validation IA, économie HITL, seuil confiance IA, file exceptions IA",
        tags: ["Exploitation de l’IA", "Validation humaine", "Économie de l’IA", "Conception des processus", "IA de production"],
      },
      {
        slug: "evaluation-gap-honest-ai-scorecard",
        cat: "Évaluation de l’IA",
        title: "L’écart d’évaluation de l’IA : bâtir une fiche décisionnelle",
        desc: "Reliez les cotes techniques aux preuves d’exploitation grâce aux évaluations hors ligne, en parallèle, contrôlées et en production qui exposent les échecs, l’incertitude, le coût et les résultats.",
        seoTitle: "Évaluation de l’IA : relier les cotes aux résultats | Vert AI",
        seoDescription: "Bâtissez une fiche décisionnelle qui relie les évaluations techniques à la qualité, aux exceptions, à l’adoption, aux coûts et aux résultats en production.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "cadre évaluation IA, indicateurs IA entreprise, surveillance modèles, fiche IA, évaluation parallèle, évaluation production",
        tags: ["Évaluation de l’IA", "Fiche décisionnelle", "Surveillance des modèles", "Exploitation de l’IA", "IA de production"],
      },
      {
        slug: "build-vs-buy-ai-2026-decision-framework",
        cat: "Stratégie d’IA",
        title: "Développer ou acheter en IA en 2026 : un cadre de décision pour la production",
        desc: "Choisissez où développer, acheter ou assembler selon la différenciation, le processus, les données, le contrôle, l’intégration, le coût total, la capacité d’exploitation, le risque fournisseur et la réversibilité.",
        seoTitle: "Développer ou acheter en IA : cadre de décision 2026 | Vert AI",
        seoDescription: "Choisissez quoi développer, acheter ou assembler selon la différenciation, les données, le contrôle, l’intégration, le coût total et le risque fournisseur.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "développer ou acheter IA, cadre décision IA, architecture IA, évaluation fournisseur IA, coût total IA, portabilité IA",
        tags: ["Stratégie d’IA", "Développer ou acheter", "Architecture d’IA", "Sélection de fournisseurs", "IA de production"],
      },
      {
        slug: "semantic-layer-undervalued-asset",
        cat: "Plateformes de données",
        title: "La couche sémantique : un sens gouverné pour l’analytique et l’IA",
        desc: "Une couche sémantique rend les entités, indicateurs, états, règles et contextes réutilisables dans l’analytique et l’IA. Voyez ce qu’elle contient, où commencer et comment l’exploiter.",
        seoTitle: "Couche sémantique pour l’analytique et l’IA | Vert AI",
        seoDescription: "Voyez comment gouverner les entités, indicateurs, états et règles afin de fournir un sens cohérent et réutilisable aux systèmes analytiques et d’IA.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "couche sémantique, indicateurs gouvernés, sémantique IA, définitions affaires, contrats données, gouvernance analytique",
        tags: ["Couche sémantique", "Plateformes de données", "Gouvernance analytique", "Données prêtes pour l’IA", "Systèmes décisionnels"],
      },
      {
        slug: "agentic-ai-production-failures",
        cat: "IA agentive",
        title: "Échecs de l’IA agentive en production : objectifs, outils, état et contrôle",
        desc: "Les systèmes agentifs échouent dans les objectifs, les autorisations, les trajectoires, l’état, la concurrence, l’évaluation, le transfert humain et le coût. Bâtissez le plan de contrôle avant l’autonomie.",
        seoTitle: "Échecs de l’IA agentive en production | Vert AI",
        seoDescription: "Anticipez les échecs liés aux objectifs, outils, autorisations, états, trajectoires et coûts grâce à un plan de contrôle avant l’autonomie.",
        date: "Juillet 2026",
        readTime: "3 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "échecs IA agentive production, sécurité agents IA, évaluation agents IA, autorisations outils, état agents, contrôles IA agentique",
        tags: ["IA agentive", "Agents d’IA", "Échecs de production", "Sécurité", "Plan de contrôle"],
      },
    ],
  },
  contact: {
    heroLabel: "Discuter d’un processus coûteux",
    heroTitle: "Présentez un processus coûteux ou une décision récurrente.",
    heroSubtitle:
      "Nous examinerons son coût opérationnel, ses limites, ses données, la personne responsable, le risque et les preuves, puis recommanderons la prochaine étape la plus crédible, y compris aucun développement lorsque c’est la bonne réponse.",
    bookingLabel: "Conversation d’adéquation",
    bookingTitle: "Planifier une discussion de cadrage",
    bookingDesc:
      "Cette conversation dirigée par le fondateur examine la valeur opérationnelle, les limites du processus, les données, la responsabilité, les risques et la possibilité d’un premier déploiement crédible. Ce n’est pas un appel générique sur l’IA.",
    bookingMeta: "Dirigé par le fondateur · processus d’abord · recommandation de ne pas construire lorsque cela s’impose",
    fallbackBooking: "Envoyer le contexte du processus",
    howToReach: "Avant l’envoi",
    scopingCall: "Le contexte nécessaire à une réponse utile.",
    scopingCallDesc:
      "Décrivez le processus actuel, l’exception ou la décision récurrente, les personnes concernées et l’indicateur opérationnel à améliorer. Ne transmettez aucune donnée client confidentielle dans ce formulaire.",
    emailLabel: "Courriel",
    locationLabel: "Bureau",
    location: "Montréal, Canada",
    responseTimeLabel: "Qui dirige le cadrage",
    responseTime: "Guillaume Belisle, fondateur",
    formLabel: "Contexte du processus",
    formTitle: "Décrivez le processus ou la décision qui coûte à l’entreprise.",
    formIntro:
      "Nommez le travail, la personne qui en est responsable et l’endroit où le coût apparaît. Seuls votre nom, votre courriel professionnel, votre entreprise et le contexte du processus sont requis.",
    formName: "Nom",
    formNamePlaceholder: "Votre nom",
    formCompany: "Entreprise",
    formCompanyPlaceholder: "Nom de l’entreprise",
    formEmail: "Courriel professionnel",
    formEmailPlaceholder: "vous@entreprise.com",
    formMessage: "Description sommaire du processus ou de la décision",
    formMessagePlaceholder:
      "Que se passe-t-il aujourd’hui? Où observez-vous des délais, du travail manuel, des incohérences, des erreurs ou des limites de capacité? Quel résultat devrait s’améliorer?",
    formSubmit: "Envoyer pour examen",
    formSending: "Envoi pour examen...",
    formSuccessTitle: "Contexte du processus reçu.",
    formSuccessDesc:
      "Vert AI l’examinera et répondra avec une proposition d’appel, une question de clarification ou une recommandation honnête de ne pas construire.",
    formErrorTitle: "La demande n’a pas pu être envoyée.",
    formErrorDesc:
      "Réessayez ou envoyez le même contexte directement par courriel.",
    validationRequired: "Ajoutez ce détail avant l’envoi.",
    validationEmail: "Entrez une adresse courriel professionnelle valide.",
    reassuranceLabel: "Ce qui se passe ensuite",
    reassuranceTitle: "Un examen d’adéquation qui respecte le temps des deux parties.",
    reassurance: [
      {
        title: "Première conversation dirigée par le fondateur",
        desc: "Vert AI examine le contexte. Guillaume dirige le cadrage et les décisions techniques clés si le mandat va de l’avant.",
      },
      {
        title: "Le processus avant la technologie",
        desc: "L’examen commence par le processus, la responsabilité, les exceptions, les données, l’économie et le changement requis — pas par un modèle ou un outil privilégié.",
      },
      {
        title: "Prochaines étapes claires",
        desc: "S’il y a adéquation, la prochaine étape précise le type de mandat, les preuves requises, les principaux risques et la décision nécessaire pour avancer.",
      },
      {
        title: "Recommandation pratique",
        desc: "Si la meilleure réponse est de ne pas construire tout de suite, Vert AI le dira et indiquera ce qu’il faut régler d’abord.",
      },
    ],
    faqLabel: "FAQ",
    faqTitle: "Questions fréquentes avant un appel de cadrage.",
    faqs: [
      {
        q: "Que se passe-t-il après l’envoi?",
        a: "Vert AI examine le processus, les données, l’échéancier et les signaux d’adéquation. Guillaume dirige le cadrage si le mandat semble approprié. La réponse propose un appel, une question de clarification ou une recommandation de ne pas construire pour l’instant.",
      },
      {
        q: "Avons-nous besoin d’un cas d’usage défini?",
        a: "Non. Un processus approximatif, une décision récurrente, un goulot d’étranglement lié aux données ou une friction opérationnelle suffit pour commencer. Vert AI peut aider à déterminer si cela devrait devenir un projet d’IA, de données, d’automatisation ou d’intelligence décisionnelle.",
      },
      {
        q: "Pouvez-vous travailler avec notre pile existante?",
        a: "Habituellement, oui. La première étape consiste à comprendre les systèmes actuels, l’accès aux données, les contraintes d’intégration, les exigences de sécurité et de confidentialité, ainsi que la personne qui sera responsable du processus après le lancement.",
      },
      {
        q: "Signez-vous des ententes de confidentialité?",
        a: "Les exigences de confidentialité peuvent être discutées avant le partage de renseignements techniques ou opérationnels sensibles. Ne transmettez aucune donnée client confidentielle dans le formulaire Web.",
      },
      {
        q: "Travaillez-vous avec des équipes hors Canada?",
        a: "Oui. Vert AI est établie au Canada et sert d’abord les entreprises canadiennes, avec certains mandats auprès d’équipes américaines.",
      },
    ],
  },
  notFound: {
    title: "Page introuvable",
    message: "Cette adresse ne mène à aucune page active de Vert AI. Retournez à l’accueil pour choisir un mandat, consulter des réalisations ou évaluer un processus.",
    backHome: "Retour à l’accueil",
  },
  footer: {
    tagline: "Correction des processus coûteux du commerce avec une IA en production, des données fiables et des contrôles opérationnels mesurables. Le Canada d’abord.",
    engagements: "Mandats",
    services: "Mandats",
    industries: "Secteurs",
    insights: "Perspectives",
    company: "La firme",
    contactLabel: "Contact",
    copyright: "Vert AI Inc.",
    bottomTagline: "IA, Données et Systèmes décisionnels · Canada",
  },
  solutionsHub: {
    heroLabel: "Solutions",
    heroTitle: "Cinq façons de corriger un travail coûteux sans perdre le contrôle.",
    heroSubtitle:
      "Partez du problème opérationnel — transferts manuels, documents complexes, connaissances dispersées, files de service ou décisions lentes — puis examinez les données, l’autorité, les contrôles et le mandat nécessaires.",
    primaryLabel: "Catégories de solutions",
    primaryTitle: "Choisir selon le problème opérationnel.",
    primarySubtitle:
      "Chaque catégorie relie un problème opérationnel récurrent au type de système, aux contrôles, aux données et au mandat qui lui conviennent.",
    secondaryLabel: "Capacités complémentaires",
    secondaryTitle: "Domaines connexes.",
    recommendationTitle: "Recommandation et personnalisation",
    recommendationDesc:
      "Moteurs de recommandation et logique de prochaine action pour le commerce électronique, le marchandisage et l’expérience client.",
    recommendationVia: "Via · Intelligence décisionnelle",
    profitabilityGrowthTitle: "Décisions de rentabilité et de croissance",
    profitabilityGrowthDesc:
      "Systèmes de mesure et de modélisation qui relient les canaux, les cohortes et les délais de récupération à l’allocation du capital.",
    profitabilityGrowthVia: "Via · Intelligence décisionnelle",
    aiOpsTitle: "Exploitation et contrôle des systèmes d’IA",
    aiOpsDesc:
      "Surveillance, assurance qualité, évaluation, règles de transmission aux responsables et garde-fous opérationnels pour les systèmes d’IA en production.",
    aiOpsVia: "Capacité transversale · Après la mise en production",
    bridgeLabel: "Choisir un mandat",
    bridgeTitle: "Du problème au bon mandat.",
    bridgeDesc:
      "Chaque solution est mise en œuvre dans le cadre du mandat qui correspond au processus opérationnel, à la fondation de données, à la couche décisionnelle ou à la question de préparation. Le périmètre, l’échéancier et l’investissement sont confirmés après l’examen d’adéquation; les livrables, les responsables, les contrôles et les critères d’acceptation sont définis avant la livraison.",
    bridgeCta: "Explorer les mandats de mise en production",
    ctaHeadline: "Présentez le processus coûteux, pas un outil privilégié.",
    ctaDesc:
      "Nous cartographierons les limites opérationnelles, les données, l’autorité, le risque de production et le premier changement crédible qui mérite d’être cadré.",
  },
  solutions: {
    aiAgents: {
      label: "Solution",
      heroTitle: "Sortez le travail en plusieurs étapes des boîtes de réception sans donner carte blanche à l’IA.",
      hubDesc:
        "Repenser le travail opérationnel répétitif autour d’une automatisation limitée, d’actions explicites, d’un acheminement des exceptions et d’une autorité humaine.",
      heroSubtitle:
        "Faire passer un processus récurrent des boîtes de réception, des feuilles de calcul et du copier-coller à un système contrôlé qui classe, recherche, rédige, met à jour les systèmes autorisés et transmet les cas dont le risque ou l’incertitude dépasse une limite définie.",
      problemLabel: "Le problème",
      problemTitle:
        "La file s’allonge. Les règles opérationnelles restent dans la tête des équipes.",
      problemP1:
        "Les équipes classent les demandes, réunissent le contexte, copient les données entre les systèmes, préparent la prochaine étape et acheminent les exceptions à la main. Les délais et les incohérences augmentent avec le volume, tandis que les scripts simples échouent dès que le parcours se ramifie ou que les données sont incomplètes.",
      problemP2:
        "Vert AI définit d’abord les limites du système : les événements qui peuvent le déclencher, les sources qu’il peut consulter, les actions qu’il peut effectuer, le niveau de confiance acceptable et les cas qui exigent l’intervention d’une personne.",
      gapsLabel: "Pourquoi les outils génériques ne suffisent pas",
      gaps:
        "Autorité de lecture, d’écriture ou d’action mal définie|Aucun parcours fiable pour les cas incertains ou à fort impact|Données sources fragiles ou droits d’accès manquants|Aucun jeu d’évaluation couvrant les cas courants et les cas limites|Aucune piste d’audit, possibilité de retour arrière ni responsabilité claire du processus",
      buildsLabel: "Ce que nous construisons",
      buildsTitle: "Les systèmes livrés dans cette catégorie.",
      builds:
        "Conception des déclencheurs, des états et des limites du système|Orchestration de règles et de modèles pour des tâches encadrées|Recherche de données autorisées et intégration aux outils|Classement, rédaction, acheminement et actions permises|Seuils de confiance et files d’exceptions|Interfaces d’approbation et de reprise en main|Jeux d’évaluation, journaux d’audit et mécanismes de retour arrière|Suivi de l’utilisation, de la qualité, de la latence, des défaillances et de la valeur mesurée",
      workflowsLabel: "Processus courants",
      workflowsTitle: "Où cette solution s’applique.",
      workflows:
        "Traitement des exceptions de commandes et d’inventaire|Triage des demandes de fournisseurs, des finances et des opérations|Enrichissement des données produit avec approbation|Acheminement des retours et des dossiers de service|Réception de documents et collecte de preuves|Coordination des tâches entre plusieurs établissements|Rapprochements et suivis récurrents",
      humanLabel: "Supervision humaine",
      humanTitle: "Les humains restent dans la boucle.",
      humanDesc:
        "Le responsable opérationnel définit où une personne approuve, modifie, examine ou arrête le processus. L’évaluation mesure la qualité de l’acheminement, l’exactitude des actions, la pertinence des exceptions, la charge de validation et l’incidence sur les opérations — pas le caractère convaincant de l’agent dans une démonstration.",
      engagementLabel: "Mandat habituel",
      engagementTitle:
        "Livrée par le parcours IA agentique et automatisation des processus.",
      engagementDesc:
        "Ce parcours convient lorsqu’un processus récurrent a un coût visible, un responsable clairement désigné, des données exploitables et une limite de validation défendable. Commencez par l’examen de vérification de l’IA lorsque la direction doit d’abord étayer une décision de financement, de lancement, de pause ou de mise à l’échelle.",
      engagementHref: "/services/production-ai-systems",
      engagementCta: "Voir le parcours d’IA agentique",
      ctaHeadline: "Présentez la file, les transferts et les exceptions.",
      ctaDesc:
        "Nous vérifierons si une automatisation encadrée peut améliorer le processus sans accorder au système une autorité qu’il ne devrait pas avoir.",
    },
    documentIntelligence: {
      label: "Solution",
      heroTitle: "Transformez le travail documentaire en actions validées et traçables.",
      hubDesc:
        "Extraction, classification et production de données structurées à partir de contrats, de factures, d’appels d’offres et de processus documentaires exigeants.",
      heroSubtitle:
        "Transformer les contrats, les factures, les formulaires, les fichiers produit, les réclamations et les documents opérationnels en données structurées validées, avec traçabilité jusqu’à la source et validation des champs incertains.",
      problemLabel: "Le problème",
      problemTitle:
        "Le document n’est pas le processus. La validation et l’action le sont.",
      problemP1:
        "Les équipes ouvrent les fichiers, déterminent le type de document, repèrent les champs pertinents, les rapprochent des politiques ou des systèmes, corrigent les exceptions et inscrivent les données approuvées dans les outils cibles. L’extraction seule n’élimine pas ce travail opérationnel.",
      problemP2:
        "Vert AI conçoit l’ensemble du parcours, de la réception à la donnée approuvée : formats pris en charge, définitions des champs, preuves tirées des sources, règles de validation, validation humaine, écritures dans les systèmes cibles et responsabilité des exceptions.",
      gapsLabel: "Pourquoi les outils génériques ne suffisent pas",
      gaps:
        "Variations de format et de langue hors du cas nominal|Champs qui exigent un contexte d’affaires, et pas seulement la reconnaissance optique de caractères|Aucune preuve source ni indication de confiance par champ|Aucun rapprochement avec les données de référence ou les politiques|Aucune file d’exceptions, boucle de correction ni écriture contrôlée dans les systèmes cibles",
      buildsLabel: "Ce que nous construisons",
      buildsTitle: "Les systèmes livrés dans cette catégorie.",
      builds:
        "Réception, classification et gestion des versions des documents|Extraction de champs et de clauses avec preuve source|Rapprochement des entités et validation selon les règles d’affaires|Seuils de confiance et files de validation|Saisie des corrections approuvées et boucle de rétroaction|Intégration des documents aux systèmes avec journaux d’audit|Jeux d’évaluation couvrant les formats et les cas limites|Surveillance de la qualité des champs, des exceptions et de la dérive",
      workflowsLabel: "Processus courants",
      workflowsTitle: "Où cette solution s’applique.",
      workflows:
        "Examen de contrats d’approvisionnement|Automatisation des comptes fournisseurs|Analyse de documents juridiques|Traitement de documents de souscription en assurance|Classification de documents de conformité|Réception et évaluation de propositions|Extraction de déclarations réglementaires",
      humanLabel: "Supervision humaine",
      humanTitle: "Les humains valident ce qui compte.",
      humanDesc:
        "Une personne approuve les champs peu fiables, contradictoires, de grande valeur ou sensibles aux politiques avant toute action du système. L’évaluation porte sur chaque champ et sur le processus : qualité de l’extraction, exactitude de la validation, capacité à repérer les exceptions, effort de validation et taux d’erreur en aval.",
      engagementLabel: "Mandat habituel",
      engagementTitle:
        "Livrée par le parcours Systèmes d’IA en production.",
      engagementDesc:
        "Choisissez le parcours Systèmes d’IA en production lorsque le parcours documentaire et l’action en aval sont clairs. Choisissez plutôt Plateformes de données pour l’IA lorsque les définitions d’entités, les données de référence ou la qualité des sources doivent d’abord être corrigées.",
      engagementHref: "/services/production-ai-systems",
      engagementCta: "Voir les systèmes d’IA en production",
      ctaHeadline:
        "Présentez les documents, les corrections et l’action en aval.",
      ctaDesc:
        "Nous cartographierons le processus complet et préciserons ce qui doit rester sous autorité humaine.",
    },
    knowledgeSystems: {
      label: "Solution",
      heroTitle: "Donnez aux équipes des réponses fiables, fondées sur des connaissances approuvées et des preuves à l’appui.",
      hubDesc:
        "Réponses traçables et soutien aux processus, fondés sur des politiques, des procédures, des données produit et des connaissances opérationnelles approuvées.",
      heroSubtitle:
        "Donner aux équipes un moyen contrôlé de trouver et d’appliquer les connaissances approuvées, avec une recherche qui respecte les droits d’accès, des citations, la capacité de s’abstenir, une boucle de rétroaction et un responsable pour chaque corpus de sources.",
      problemLabel: "Le problème",
      problemTitle:
        "La réponse existe, mais on ne sait pas si elle fait autorité ni si elle est à jour.",
      problemP1:
        "Les politiques, les procédures, les données sur les produits et les connaissances commerciales sont dispersées dans des espaces partagés, des wikis, des demandes de soutien et des outils hérités. La recherche peut trouver un document sans établir s’il est à jour, autorisé ou suffisant pour la décision de l’utilisateur.",
      problemP2:
        "Vert AI définit les limites du système de connaissances : sources approuvées, droits d’accès, règles de version et de mise à jour, recherche, citations, abstention, rétroaction et action opérationnelle qui suit la réponse.",
      gapsLabel: "Pourquoi la recherche générique ne suffit pas",
      gaps:
        "Sources périmées ou contradictoires sans responsable clairement désigné|Fuite d’information entre des équipes ou des rôles qui n’ont pas les mêmes droits|Réponses sans citations ni traçabilité jusqu’à la source|Recherche qui manque le bon passage ou invente un lien entre les sources|Aucune abstention, rétroaction ni jeu d’évaluation fondé sur des questions représentatives",
      buildsLabel: "Ce que nous construisons",
      buildsTitle: "Les systèmes livrés dans cette catégorie.",
      builds:
        "Inventaire des sources, responsables et modèle de droits d’accès|Processus d’intégration, de version, de mise à jour et de suppression|Recherche hybride adaptée à des questions représentatives|Citations, indication de confiance et comportement d’abstention|Interfaces adaptées aux rôles dans le processus opérationnel|Files de rétroaction, de correction et de lacunes de connaissances|Évaluation de la recherche, de la fidélité aux sources et de l’utilité des réponses|Surveillance de l’état des sources, des défaillances et de l’utilisation",
      workflowsLabel: "Processus courants",
      workflowsTitle: "Où cette solution s’applique.",
      workflows:
        "Questions sur les politiques de ressources humaines et les avantages sociaux|Recherche de connaissances pour le soutien technique|Outils d’aide à la vente et information produit|Accès aux connaissances de conformité réglementaire|Accès aux connaissances pour l’accueil et la formation|Consultation des procédures opérationnelles|Partage des connaissances entre services",
      humanLabel: "Supervision humaine",
      humanTitle:
        "Les personnes responsables gardent l’autorité sur les connaissances et les actions.",
      humanDesc:
        "Les responsables de contenu approuvent les sources et les corrections. Les utilisateurs peuvent vérifier les citations et transmettre une réponse pour examen. Les actions à fort impact restent hors de la portée de l’assistant, sauf si un processus contrôlé distinct lui accorde explicitement cette autorité.",
      engagementLabel: "Mandat habituel",
      engagementTitle:
        "Livrée par le parcours Systèmes d’IA en production.",
      engagementDesc:
        "Ce parcours convient lorsque la tâche de recherche, les responsables des sources, les utilisateurs, les droits d’accès et l’action suivante sont clairs. Commencez par Plateformes de données pour l’IA lorsque la qualité des sources, les définitions d’entités ou les règles d’accès constituent le risque principal.",
      engagementHref: "/services/production-ai-systems",
      engagementCta: "Voir les systèmes d’IA en production",
      ctaHeadline:
        "Présentez les questions, les sources approuvées et la décision qui suit.",
      ctaDesc:
        "Nous vérifierons si la recherche est le bon mécanisme et quelles preuves les utilisateurs doivent voir pour lui faire confiance.",
    },
    customerSupport: {
      label: "Solution",
      heroTitle: "Réduisez l’effort de service sans perdre le contrôle des politiques ni des transferts.",
      hubDesc:
        "Triage, assistance aux agents, résolution encadrée et transmission conçus selon la qualité de service et le risque pour la clientèle.",
      heroSubtitle:
        "Repenser la réception des demandes, leur classement, la collecte du contexte, la préparation des réponses, les actions de résolution permises et le transfert à une personne comme un seul processus de service mesurable.",
      problemLabel: "Le problème",
      problemTitle:
        "Le volume augmente, tandis que la recherche du contexte et le jugement restent manuels.",
      problemP1:
        "Les agents classent l’intention, cherchent le contexte du compte et les politiques, rédigent des réponses, choisissent une action et décident quand transférer le dossier. Un robot conversationnel qui répond aux questions sans respecter l’état du compte, les politiques, les droits d’accès ou l’incidence sur la clientèle ajoute une file au lieu de réduire le travail.",
      problemP2:
        "Vert AI définit les demandes pour lesquelles le système peut assister l’agent ou apporter une résolution, les données qu’il peut consulter, les actions permises et les conditions qui imposent un transfert à la bonne personne.",
      gapsLabel: "Pourquoi les robots conversationnels génériques ne suffisent pas",
      gaps:
        "Étiquettes d’intention et de priorité peu fiables|Connaissances dissociées du contexte du compte et de la commande|Aucun modèle d’actions permises pour les remboursements, les changements ou les exceptions|Transferts qui perdent le contexte ou surviennent trop tard|Aucune évaluation de la qualité de résolution, du respect des politiques ou du préjudice potentiel pour la clientèle",
      buildsLabel: "Ce que nous construisons",
      buildsTitle: "Les systèmes livrés dans cette catégorie.",
      builds:
        "Modèles d’intention, d’urgence et d’acheminement dès la réception|Recherche du compte, de la commande, des politiques et des connaissances|Propositions de réponse avec contexte tiré des sources|Actions de résolution encadrées par des règles d’approbation|Seuils de confiance, de risque et d’incidence sur la clientèle|Prise en charge par une personne avec conservation du contexte et possibilité de modification|Évaluation de l’acheminement, des réponses, des actions et du respect des politiques|Surveillance de la résolution sans transfert, des reprises, des transmissions et des résultats de service",
      workflowsLabel: "Processus courants",
      workflowsTitle: "Où cette solution s’applique.",
      workflows:
        "Automatisation du soutien de premier niveau|Demandes sur l’état et le suivi des commandes|Traitement des retours et des échanges|Questions sur les comptes et la facturation|Demandes d’information sur les produits|Planification et coordination des services|Classement et acheminement des plaintes",
      humanLabel: "Supervision humaine",
      humanTitle: "Les agents gardent le contrôle.",
      humanDesc:
        "Les agents demeurent responsables des cas sensibles, ambigus, de grande valeur ou critiques pour la relation. Ils peuvent examiner le contexte, modifier ou rejeter les suggestions, annuler une action et intégrer les corrections au processus d’évaluation.",
      engagementLabel: "Mandat habituel",
      engagementTitle:
        "Livrée par le parcours Systèmes d’IA en production.",
      engagementDesc:
        "Ce parcours convient lorsqu’une file de demandes a un volume suffisant, un responsable clairement désigné, un contexte accessible et une autorité humaine bien définie. L’examen de vérification de l’IA ou le parcours Plateformes de données pour l’IA peut devoir venir d’abord lorsque les éléments de preuve, les étiquettes, les politiques ou les intégrations sont peu fiables.",
      engagementHref: "/services/production-ai-systems",
      engagementCta: "Voir les systèmes d’IA en production",
      ctaHeadline:
        "Présentez la file, les règles de service et les transferts les plus difficiles.",
      ctaDesc:
        "Nous définirons où l’assistance est utile, où l’automatisation est sécuritaire et où une personne doit conserver le contrôle.",
    },
    predictiveModels: {
      label: "Solution",
      heroTitle: "Transformez les prévisions et les cotes en décisions récurrentes gouvernées.",
      hubDesc:
        "Prévision, attribution de cotes et priorisation intégrées à un processus décisionnel capable d’agir sur le signal.",
      heroSubtitle:
        "Faire sortir la prévision, l’attribution de cotes et la priorisation des carnets d’analyse et des tableaux de bord pour les intégrer à un processus décisionnel gouverné, avec seuils, explications, jugement humain, collecte des résultats et surveillance.",
      problemLabel: "Le problème",
      problemTitle:
        "Une prédiction n’a de valeur que si l’équipe opérationnelle peut agir.",
      problemP1:
        "Les tableaux de bord décrivent le passé et les carnets d’analyse produisent des cotes, mais les équipes continuent de décider dans des feuilles de calcul et des réunions. Il manque les règles qui encadrent le modèle : qui reçoit le signal, quel seuil modifie une action, quelles contraintes s’appliquent et comment le résultat alimente la boucle de rétroaction.",
      problemP2:
        "Vert AI cadre la décision avant le modèle, puis construit les données, la prédiction, le seuil, la validation, l’action et la boucle d’apprentissage comme un seul système.",
      gapsLabel: "Pourquoi les tableaux de bord ne suffisent pas",
      gaps:
        "Aucune décision ni action convenue, et aucun responsable désigné|Variables cibles historiques qui ne représentent pas le résultat réel|Fuite de données, biais, dérive ou définitions d’affaires instables|Aucune règle de seuil ni contrainte de capacité|Aucune collecte du résultat pour vérifier si la décision s’est améliorée",
      buildsLabel: "Ce que nous construisons",
      buildsTitle: "Les systèmes livrés dans cette catégorie.",
      builds:
        "Définition de la décision et mesure de référence|Données d’entraînement, variables cibles, fuites et contrôles de qualité|Modèles de prévision, d’attribution de cotes, de classement ou de classification|Conception des règles de seuil et de capacité|Explication et interface de décision humaine|Intégration au processus par lots ou en temps réel|Collecte des résultats et des interventions humaines|Surveillance de la performance, de la dérive, de l’utilisation et de la valeur",
      workflowsLabel: "Décisions courantes",
      workflowsTitle: "Les décisions que nous améliorons.",
      workflows:
        "Quels clients sont les plus susceptibles de partir|Où affecter l’effort commercial|Quels niveaux d’inventaire maintenir|Quels prospects prioriser|Comment segmenter les clients selon leur valeur|Où ajuster les prix|Dans quelles cohortes marketing investir",
      humanLabel: "Aide à la décision, pas remplacement",
      humanTitle: "Les modèles informent. Les humains décident.",
      humanDesc:
        "Le responsable d’affaires définit les règles et conserve l’autorité sur les exceptions, les ressources limitées et les décisions à fort impact. L’évaluation couvre la qualité du modèle et celle de la décision : calibration, qualité du classement, compromis associés aux seuils, interventions humaines, utilisation et résultat opérationnel.",
      engagementLabel: "Mandat habituel",
      engagementTitle:
        "Livrée par le parcours Intelligence décisionnelle.",
      engagementDesc:
        "Ce parcours convient lorsque la décision récurrente, l’action possible, la variable de résultat, le responsable et la mesure de référence sont suffisamment clairs. Commencez par l’examen de vérification de l’IA ou le parcours Plateformes de données pour l’IA lorsque ce n’est pas le cas.",
      engagementHref: "/services/decision-intelligence",
      engagementCta: "Voir le parcours d’intelligence décisionnelle",
      ctaHeadline:
        "Nommez la décision, l’action et la conséquence mesurable.",
      ctaDesc:
        "Nous vérifierons si un système prédictif peut améliorer la décision opérationnelle, et non seulement produire une cote plus sophistiquée.",
    },
  },
  seo: {
    home: {
      title: "Corriger les processus coûteux du commerce avec l’IA | Vert AI",
      description: "Vert AI corrige les processus coûteux du commerce en repensant le travail et en construisant l’IA, les données fiables, les contrôles et la mesure nécessaires.",
      keywords: "systèmes d’IA en production, processus de commerce, mise en œuvre de l’IA au Canada, automatisation des processus, systèmes décisionnels",
    },
    services: {
      title: "Mandats d’IA en production pour les opérations | Vert AI",
      description: "Commencez par un examen décisionnel fondé sur les preuves. Choisissez parmi quatre parcours : IA en production, automatisation agentique, données ou décision.",
      keywords: "examen de vérification de l’IA au Canada, systèmes d’IA en production, automatisation agentique, plateformes de données pour l’IA, intelligence décisionnelle",
    },
    dataPlatforms: {
      title: "Plateformes de données pour l’IA | Vert AI",
      description: "Construisez les chaînes de traitement, les définitions, les contrôles de qualité, les autorisations, le lignage et les mécanismes d’activation requis par un système d’IA fiable.",
      keywords: "fondations de données IA, qualité des données, couche sémantique, gouvernance des données, ingénierie des données Canada",
    },
    solutions: {
      title: "Solutions d’IA pour les processus coûteux du commerce | Vert AI",
      description: "Découvrez cinq modèles contrôlés pour les transferts manuels, les documents, les connaissances dispersées, les files de service et les décisions récurrentes.",
      keywords: "solutions d’IA en production, automatisation processus, intelligence documentaire, recherche d’entreprise, modèles prédictifs",
    },
    aiAgents: {
      title: "Agents IA encadrés et automatisation de processus | Vert AI",
      description: "Repensez un processus récurrent avec acheminement explicite, autorisations limitées, solutions de repli, autorité humaine et évaluation en production.",
      keywords: "agents IA encadrés, automatisation processus, validation humaine, évaluation IA, IA en production",
    },
    documentIntelligence: {
      title: "Intelligence documentaire et gestion des exceptions | Vert AI",
      description: "Transformez des documents en données validées grâce à l’extraction, aux seuils de confiance, aux files d’exceptions et à la validation humaine traçable.",
      keywords: "intelligence documentaire, extraction de documents, gestion des exceptions, validation humaine, traitement documentaire",
    },
    knowledgeSystems: {
      title: "Recherche d’entreprise avec sources citées | Vert AI",
      description: "Construisez une recherche gouvernée dans les politiques, procédures, données produit et documents commerciaux, avec contrôles d’accès, citations et évaluation.",
      keywords: "recherche d’entreprise, génération augmentée de récupération, citations, contrôle d’accès, évaluation recherche",
    },
    customerSupport: {
      title: "IA pour le service à la clientèle avec relais humain | Vert AI",
      description: "Concevez le triage, l’aide aux conseillers et la résolution avec des réponses fondées sur les sources et un transfert humain contrôlé.",
      keywords: "IA service à la clientèle, aide aux conseillers, triage, relais humain, réponses fondées sur les sources",
    },
    predictiveModels: {
      title: "Modèles prédictifs intégrés aux décisions | Vert AI",
      description: "Construisez des systèmes de prévision, de cotation et de priorisation avec seuils décisionnels, autorité humaine, surveillance et rétroaction.",
      keywords: "modèles prédictifs, apprentissage automatique appliqué, prévision de demande, seuils décisionnels, surveillance des modèles",
    },
    industries: {
      title: "IA en production pour les opérations de commerce | Vert AI",
      description: "Explorez les processus, données, contrôles et conditions de préparation propres au commerce de détail, aux biens de consommation et aux réseaux multisites.",
      keywords: "IA pour le commerce de détail au Canada, IA pour le commerce électronique, biens de consommation, IA pour les franchises, automatisation des processus de commerce",
    },
    work: {
      title: "Mandats réels et anonymisés en IA | Vert AI",
      description: "Examinez quatre mandats réels et anonymisés : problème opérationnel, intervention, contrôles de production, cadre de mesure et limites des preuves publiées.",
      keywords: "mandats IA en production, réalisations anonymisées, preuves de livraison IA, contrôles de production",
    },
    aiReadinessScorecard: {
      title: "Grille indicative de préparation à l’IA | Vert AI",
      description: "Utilisez une grille sans formulaire obligatoire, dont les dimensions ont le même poids, afin de voir ce qui doit être renforcé avant un système en production.",
      keywords: "grille préparation IA, préparation IA en production, évaluation processus IA, cartographie occasions IA",
    },
    insights: {
      title: "Guides de décision en IA pour les équipes d’achat | Vert AI",
      description: "Seize guides pour évaluer la valeur des processus, la préparation, les données, les contrôles, l’économie, les fournisseurs et le risque de production.",
      keywords: "guides IA en production, sélection processus IA, gouvernance IA, évaluation IA, rendement IA, préparation des données",
    },
    about: {
      title: "À propos de Vert AI | Responsabilité directe en production",
      description: "Comment Vert AI corrige des processus coûteux avec un cadrage dirigé par le fondateur, des décisions prises au plus haut niveau et des preuves par phases.",
      keywords: "Vert AI, Guillaume Belisle, mise en œuvre de l’IA dirigée par le fondateur, IA en production au Canada",
    },
    contact: {
      title: "Discuter d’un processus coûteux du commerce | Vert AI",
      description: "Présentez un processus coûteux, son responsable, les systèmes et le coût visible. Vert AI recommandera une prochaine étape crédible.",
      keywords: "contacter Vert AI, discuter processus IA, conseil IA en production Canada",
    },
    privacy: {
      title: "Confidentialité du site Web | Vert AI",
      description: "Comment Vert AI traite les renseignements transmis par le site, le formulaire de contact, la grille de préparation, l’analytique et les liens externes.",
    },
    notFound: {
      title: "Page introuvable | Vert AI",
      description: "La page que vous cherchez n’existe pas ou a été déplacée.",
    },
    unsubscribe: {
      title: "Désabonnement | Vert AI",
      description: "Gérez vos préférences courriel.",
    },
  },
};
